import * as actions from './actions'

const IntegrationStore = {
  state: {},
  getters: {},
  mutations: {},
  actions
}

export default IntegrationStore
